import { useEffect, useState } from "react";
/** Keep overlays in the browser's fullscreen top layer. */
export function usePortalContainer(container) {
    const [fullscreen, setFullscreen] = useState(null);
    useEffect(() => {
        const update = () => setFullscreen(document.fullscreenElement);
        update();
        document.addEventListener("fullscreenchange", update);
        return () => document.removeEventListener("fullscreenchange", update);
    }, []);
    return container ?? fullscreen ?? undefined;
}
//# sourceMappingURL=portal-container.js.map